import { Formik } from 'formik';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import React, { RefObject } from 'react';
import { Box, Flex } from 'reflexbox';
import moment from 'moment';
import { Panel } from 'primereact/panel';
import { MonitoringRestService } from '../../services/MonitoringRestService';
import { DependencyContainer } from '../../utils/DependencyInjection';
import _ from 'lodash';

export interface IMonitoringFeeDetailFilterContainerValue {
  titleName?: any;
  category?: any;
}

export class MonitoringFeeDetailFilterContainer extends React.Component<any, any> {
  monitoringRestService = DependencyContainer.get(MonitoringRestService);
  initialFormValues: IMonitoringFeeDetailFilterContainerValue = {
    titleName: '',
    category: '',
  };
  refFormik: RefObject<Formik> = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      filterCollapsed: false,
      optionCategory: null,
      optionEmployee: null,
    }
  }

  componentDidMount() {
    this.monitoringRestService.get("monitoring-penalty/penalty-category/list").subscribe(
      (response) => {
        console.log(response);
        response = _.map(response, e => {
          return {
            label: e.penalty_category_title,
            value: e.penalty_category_id
          }
        })
        response.push({label: 'Semua', value: ''})
        this.setState({
          optionCategory: response,
        })
      },
      () => {
        // this.dataSource.loading = false;
      },
      () => {
        // this.dataSource.loading = false;
      }
    );
    this.monitoringRestService.get("monitoring-penalty/employee-role/list").subscribe(
      (response) => {
        console.log(response);
        response = _.map(response, e => {
          return {
            label: e.employee_role_name + ' (' + e.employee_role_code + ')',
            value: e.employee_role_id
          }
        })
        response.push({label: 'Semua', value: ''})
        this.setState({
          optionEmployee: response,
        })
      },
      () => {
        // this.dataSource.loading = false;
      },
      () => {
        // this.dataSource.loading = false;
      }
    );
  }

  get formValues() {
    if (this.refFormik.current) {
      return this.refFormik.current.state.values;
    }

    return {};
  }

  render() {
    return (
      <Panel header="Filter" toggleable={true} collapsed={this.state.filterCollapsed} onToggle={(e) => this.setState({ filterCollapsed: e.value })}>
        <div className="row">
          <div className="col-md-12">
            <div>
              <Formik
                ref={this.refFormik}
                enableReinitialize
                initialValues={this.initialFormValues}
                onSubmit={() => { }}>
                {formikProps => (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="col-md-1">Jabatan</label>
                        <div className="col-md-4">
                          <Dropdown
                            options={this.state.optionEmployee}
                            onChange={formikProps.handleChange("titleName")}
                            value={formikProps.values.titleName}
                            filter={true}
                          />
                        </div>
                      </div>
                    </div>
                    <br/>
                    <br/>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="col-md-1">Kategori</label>
                        <div className="col-md-3">
                          <Dropdown
                            options={this.state.optionCategory}
                            onChange={formikProps.handleChange("category")}
                            value={formikProps.values.category}
                            filter={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </Panel>
    );
  }
}
